/*
 * @Author: your name
 * @Date: 2020-09-07 15:35:39
 * @LastEditTime: 2020-09-07 16:13:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /vip-center-2/src/store/userInfo.js
 */
import { observable } from 'mobx'
import { parse } from 'qs'
// import { observable, computed } from 'mobx'
import SDK from '../sdk/utils'
import * as network from '../network/network'
class UserInfoStore {
    constructor() {
        // 对于组件渲染过程中要用到的数据
        // 不建议采用这种方式，会造成异步问题，组件内逻辑无法正常使用
        this.getOversea();
        this.checkLogin();
        this.getVipStat();
    }
    @observable userInfo = {} // 用户信息
    @observable isLogin = false; // 登陆状态
    @observable phoneType = SDK.isIos ? 'ios' : 'android'// 设备信息
    @observable oversea = 0 // 海外客户端
    @observable vipInfo = {year:[
      {click_flag:null}
      ,{click_flag:null}
    ]}// 获取用户VIP相关信息
    // changeState(callback) {
    //   setTimeout(() => {
    //     callback()
    //   },2000)
    // }
    getOversea () {
      const queryArray = window.location.href.split('?')
      const params = parse(queryArray[queryArray.length - 1])
      this.oversea = params.oversea
    }
    async getVipStat () {
        try {
            const vipStat = (await network.getVipInfo(this.oversea)).data;
            // console.log(vipStat)
            this.vipInfo = vipStat;
        } catch(E) {

        }
    }
    // 登陆校验
    async checkLogin () {
        try {
          if (await SDK.isLogin()) {
            this.isLogin = true
            await this.getUserInfo()
          }
        } catch (E) {
          console.log('NOT LOGIN')
          console.error(E)
        }
    }
    // 获取用户信息
    async getUserInfo () {
      try {
        const userInfo = await SDK.getUserInfo()
        this.userInfo = userInfo
      } catch (E) {
        console.error(E)
      }
    }
    // 手机类型
    getPhoneType() {
        return this.phoneType;
    }
    // 设置登陆状态
    async refreshLoginState() {
      if (await SDK.isLogin()) {
          this.isLogin = true;
          await this.getVipStat()
      }
    }
    // 购买
    payBill() {

    }
}
export default UserInfoStore;